import { Recipe } from '@core/shopping';

interface RecipeListProps {
  recipes: Recipe[];
  onRemoveRecipe: (recipeId: string) => void;
  onGenerateList: () => void;
}

export function RecipeList({ recipes, onRemoveRecipe, onGenerateList }: RecipeListProps) {
  if (recipes.length === 0) {
    return (
      <div className="bg-white shadow rounded-lg p-12 text-center">
        <svg
          className="mx-auto h-12 w-12 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
          />
        </svg>
        <h3 className="mt-2 text-sm font-medium text-gray-900">No recipes yet</h3>
        <p className="mt-1 text-sm text-gray-500">
          Add your first recipe using the form above.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-900">
          My Recipes ({recipes.length})
        </h2>
        <button
          onClick={onGenerateList}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700"
        >
          Generate Shopping List
        </button>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {recipes.map((recipe) => (
          <div key={recipe.id} className="bg-white shadow rounded-lg p-6">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-gray-900">{recipe.name}</h3>
                <p className="text-sm text-gray-500 mt-1">
                  Servings: {recipe.servings} • {recipe.ingredientLines.length} ingredients
                </p>
              </div>
              <button
                onClick={() => onRemoveRecipe(recipe.id)}
                className="ml-4 text-gray-400 hover:text-red-600"
              >
                <svg
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
              </button>
            </div>

            <div className="mt-4">
              <h4 className="text-sm font-medium text-gray-700 mb-2">Ingredients:</h4>
              <ul className="space-y-1">
                {recipe.ingredientLines.map((line, i) => (
                  <li key={i} className="text-sm text-gray-600 font-mono">
                    • {line}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
